
export  const linksHandler = (link) => {
    window.open(link, "_blank", "noopener, noreferrer"); 
  }
